<div class="dates-label">

  <span class="badge">
    <strong>Entered</strong> {{ item.dates?.entered | date }}
  </span>
  <span class="badge">
    <strong>Changed</strong> {{ item.dates?.changed | date }}
  </span>
</div>
